import { SkinData } from './data.interfaces';
export const skins: SkinData[] = [
  {
    name: 'Emoji Modifier Fitzpatrick Type-1-2',
    unified: '1F3FB',
    sheet: [12, 25],
    hidden: ['messenger'],
    shortName: 'skin-tone-2'
  },
  {
    name: 'Emoji Modifier Fitzpatrick Type-3',
    unified: '1F3FC',
    sheet: [12, 26],
    hidden: ['messenger'],
    shortName: 'skin-tone-3'
  },
  {
    name: 'Emoji Modifier Fitzpatrick Type-4',
    unified: '1F3FD',
    sheet: [12, 27],
    hidden: ['messenger'],
    shortName: 'skin-tone-4'
  },
  {
    name: 'Emoji Modifier Fitzpatrick Type-5',
    unified: '1F3FE',
    sheet: [12, 28],
    hidden: ['messenger'],
    shortName: 'skin-tone-5'
  },
  {
    name: 'Emoji Modifier Fitzpatrick Type-6',
    unified: '1F3FF',
    sheet: [12, 29],
    hidden: ['messenger'],
    shortName: 'skin-tone-6'
  }
];
